import { TFunction } from 'i18next';

import i18n from 'src/infrastructure/i18n/i18next.client';

export const PROFIT_LOSS_GROUP_LABELS = new Map([
    ['OneTimeCostItem', 'One-time costs'],
    ['YearlyCostItem', 'Yearly costs'],
    ['DepreciationCostItem', 'Depreciation costs'],
    ['OneTimeProfitItem', 'One-time profits'],
]);

// Backend item names may carry a dynamic unit-price suffix, e.g. "PV panels (per kWp: 450.00)".
// The base name and the suffix are translated separately so the dynamic value passes through.
const PER_UNIT_SUFFIX = /^(.+?) \(per (kWp|kWh): ([\d.,]+)\)$/;

export function translateProfitLossGroup(type: string, t: TFunction): string {
    const label = PROFIT_LOSS_GROUP_LABELS.get(type);
    return label ? t(label) : type;
}

export function translateProfitLossItemName(name: string, t: TFunction): string {
    const match = name.match(PER_UNIT_SUFFIX);
    if (match) {
        const [, base, unit, value] = match;
        const parsed = Number(value);
        const localizedValue = Number.isNaN(parsed)
            ? value
            : parsed.toLocaleString(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return `${t(base)} ${t('(per {{unit}}: {{value}})', { unit, value: localizedValue })}`;
    }
    return t(name);
}
